import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings',
  'HomeService',
  '$uibModal',
  '$timeout',
  'CartService'
];

class BrandsController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings, HomeService, $uibModal, $timeout, CartService) {
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.HomeService  = HomeService;
    this.CartService = CartService;
    this.$timeout = $timeout;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }

  $onInit(){
    this.getBrands();
  }

  getBrands() {
    // let userId = '';
    // try{ userId = this.shCtrl.currentUser.userId; }
    // catch(e){}
    // this.HomeService.getBrands(userId, 10).then(response => {
    //   this.featuredProducts = response;
    //   this.featuredProducts1 = [];
    //   this.featuredProducts2 = [];
    //   if(response.length){
    //     response.forEach((valFor, indexFor) => {
    //       if(indexFor <= ((response.length - 1) / 2) || response.length < 8) {
    //         this.featuredProducts1.push(valFor);
    //       } else {
    //         this.featuredProducts2.push(valFor);
    //       }
    //     });
    //   }
    //   this.initRelatedProductsCarousel();
    //   // initBrandsCarousel();
    //
    //   this.loadingRelatedProducts = false;
    // }).catch(error => {
    //
    // });
    this.initBrandsCarousel();
  }

  initBrandsCarousel() {
    this.$timeout(function(){

      let brandsItemsSlider = $('.brands-slider.owl-carousel');
      brandsItemsSlider.owlCarousel({
        items: 6,
        itemsDesktop : [1199,3],
        itemsDesktopSmall: [979,2],
        itemsTablet: [768,2],
        itemsMobile : [479,1],
        slideSpeed: 400,
        autoPlay: 8000,
        stopOnHover: true,
        navigation: false,
        pagination: false,
        responsive: true,
        mouseDrag: false,
        autoHeight : false
      }).data('navigationBtns', ['#brands-slider-prev', '#brands-slider-next']);
      brandsItemsSlider.each(function() {
        let $this = $(this),
          owlCarousel = $this.data('owlCarousel'),
          owlBtns = $this.data('navigationBtns'),
          prevBtn, nextBtn;

        if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
          return;
        }

        for(let key in owlBtns) {
          if (owlBtns[key].indexOf('next') === -1) {
            prevBtn = $(owlBtns[key]);
          }else {
            nextBtn = $(owlBtns[key]);
          }
        }

        prevBtn.on('click touchstart', function(e) {
          owlCarousel.prev();
          e.preventDefault();
        });

        nextBtn.on('click touchstart', function(e) {
          owlCarousel.next();
          e.preventDefault();
        });
      });

      $('.add-tooltip').tooltip();
    },1000);
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }

}

BrandsController.$inject = inject;

export default BrandsController;




// WEBPACK FOOTER //
// ./www/components/home/brands/brands.controller.js